import { render, staticRenderFns } from "./TestBroadcastDialog.vue?vue&type=template&id=58e8f328&"
import script from "./TestBroadcastDialog.vue?vue&type=script&lang=js&"
export * from "./TestBroadcastDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports